module.exports = __webpack_public_path__ + "img/TH.3530959a.svg";